var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiWarehouseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_26610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8.18601V3.81423C11 3.23214 10.6857 2.69483 10.1729 2.40582L6.32707 0.219931C5.81429 -0.0690785 5.18571 -0.0690785 4.67293 0.219931L0.827068 2.40582C0.314286 2.69483 0 3.23214 0 3.81423V8.18601C0 8.7681 0.314286 9.30541 0.827068 9.59442L4.67293 11.7803C5.18571 12.0693 5.81429 12.0693 6.32707 11.7803L10.1729 9.59442C10.6857 9.30541 11 8.7681 11 8.18601Z",
    fill: "#0100C6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip1_206_26610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 28.186V23.8142C11 23.2321 10.6857 22.6948 10.1729 22.4058L6.32707 20.2199C5.81429 19.9309 5.18571 19.9309 4.67293 20.2199L0.827068 22.4058C0.314286 22.6948 0 23.2321 0 23.8142V28.186C0 28.7681 0.314286 29.3054 0.827068 29.5944L4.67293 31.7803C5.18571 32.0693 5.81429 32.0693 6.32707 31.7803L10.1729 29.5944C10.6857 29.3054 11 28.7681 11 28.186Z",
    fill: "#0100C6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip2_206_26610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 8.18601V3.81423C29 3.23214 28.6857 2.69483 28.1729 2.40582L24.3271 0.219931C23.8143 -0.0690785 23.1857 -0.0690785 22.6729 0.219931L18.8271 2.40582C18.3143 2.69483 18 3.23214 18 3.81423V8.18601C18 8.7681 18.3143 9.30541 18.8271 9.59442L22.6729 11.7803C23.1857 12.0693 23.8143 12.0693 24.3271 11.7803L28.1729 9.59442C28.6857 9.30541 29 8.7681 29 8.18601Z",
    fill: "#0100C6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_206_26610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 28.186V23.8142C29 23.2321 28.6857 22.6948 28.1729 22.4058L24.3271 20.2199C23.8143 19.9309 23.1857 19.9309 22.6729 20.2199L18.8271 22.4058C18.3143 22.6948 18 23.2321 18 23.8142V28.186C18 28.7681 18.3143 29.3054 18.8271 29.5944L22.6729 31.7803C23.1857 32.0693 23.8143 32.0693 24.3271 31.7803L28.1729 29.5944C28.6857 29.3054 29 28.7681 29 28.186Z",
    fill: "#0100C6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_206_26610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 18.186V13.8142C20 13.2321 19.6857 12.6948 19.1729 12.4058L15.3271 10.2199C14.8143 9.93092 14.1857 9.93092 13.6729 10.2199L9.82707 12.4058C9.31429 12.6948 9 13.2321 9 13.8142V18.186C9 18.7681 9.31429 19.3054 9.82707 19.5944L13.6729 21.7803C14.1857 22.0693 14.8143 22.0693 15.3271 21.7803L19.1729 19.5944C19.6857 19.3054 20 18.7681 20 18.186Z",
    fill: "#0100C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_26610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_206_26610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(0 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_206_26610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_206_26610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(18 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_206_26610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiWarehouseActive);
export default __webpack_public_path__ + "static/media/multi-warehouse-active.14ef353a7a374abdf03870353a15a924.svg";
export { ForwardRef as ReactComponent };